import type { EitherTranslatedOrError, SimpleFormatMessage } from 'components/secondaryMarket/shared/Clipboard/types';
import type { CpOrderSettlementType } from 'state/secondaryMarket/cpOrder/referential/client/client.model';

export const translateSettlementType = (
  pastedValue: string,
  formatSimpleMessage: SimpleFormatMessage,
  metadata?: unknown,
) => {
  const settlementsTypes = (metadata as CpOrderSettlementType[] | undefined) ?? [];

  const settlementType = settlementsTypes.find(x => x.settlementType === pastedValue);
  if (settlementType) {
    return { status: 'success', value: settlementType } as EitherTranslatedOrError<CpOrderSettlementType>;
  }

  const error = formatSimpleMessage('moreMenu.pasteFromClipboard.error.invalidNotInTheList', { value: pastedValue });
  return { status: 'error', error } as EitherTranslatedOrError<CpOrderSettlementType>;
};
